import { FetchSchool } from "api";
import { SchoolClassesState, SchoolIDState } from "global-states";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

export function useSchoolInfo() {
	const schoolID = useRecoilValue(SchoolIDState);
	const [classes, setClasses] = useRecoilState(SchoolClassesState);
	const [error, setError] = useState("");
	useEffect(() => {
		if (schoolID === "") return;
		FetchSchool(schoolID)
			.then((res) => {
				setClasses(res.data || []);
			})
			.catch((err) => {
				setError(JSON.stringify(err));
			});
	}, [schoolID, setClasses]);

	return {
		classes,
		error,
	};
}
